import {
  createUser as createUserRequest,
  disableStatusPageEmails,
  disableUser as disableUserRequest,
  enableStatusPageEmails,
  enableUser as enableUserRequest,
  getCurrentUser as getCurrentUserRequest,
  searchUsers as searchUsersRequest,
  updateUser as updateUserRequest,
  updateUserCurrentOrganization,
  updateUserCurrentPartner,
  updateUserRole as updateUserRoleRequest
} from '@/api/generated/user/user'
import {
  CurrentUserDTO,
  UserDTO,
  UserDetailsDTO,
  CreateUserRequest,
  SearchRequest,
  UpdateUserRequest
} from '@/api/generated/model'
import { SearchResult } from '@/api/search-result'

export const createUser = async (
  request: CreateUserRequest
): Promise<UserDTO> => {
  const response = await createUserRequest(request)
  return response.data
}

export const searchUsers = async (
  request?: SearchRequest
): Promise<UserDTO[]> => {
  // A missing request goes out with no body, as before.
  const response = await searchUsersRequest(request!)
  return response.data
}

export const getCurrentUser = async (): Promise<CurrentUserDTO> => {
  const response = await getCurrentUserRequest()
  return response.data
}

export const updateUser = async (
  request: UpdateUserRequest
): Promise<UserDTO> => {
  const response = await updateUserRequest(request)
  return response.data
}

export const updateCurrentPartner = async (
  partnerID: string
): Promise<CurrentUserDTO> => {
  const response = await updateUserCurrentPartner(partnerID)
  return response.data
}

// Super Admin only: sets the organization to view the application as.
// Selecting the user's own organization clears the override.
export const updateCurrentOrganization = async (
  organizationID: string
): Promise<CurrentUserDTO> => {
  const response = await updateUserCurrentOrganization(organizationID)
  return response.data
}

// DEV-1676: turns status page update emails on or off for the current user.
export const updateStatusPageEmails = async (
  enabled: boolean
): Promise<CurrentUserDTO> => {
  const response = enabled
    ? await enableStatusPageEmails()
    : await disableStatusPageEmails()
  return response.data
}

export const updateUserRole = async (
  userID: string,
  roleID: string
): Promise<UserDetailsDTO> => {
  const response = await updateUserRoleRequest(userID, roleID)
  return response.data
}

export const enableUser = async (userID: string): Promise<UserDTO> => {
  const response = await enableUserRequest(userID)
  return response.data
}

export const disableUser = async (userID: string): Promise<UserDTO> => {
  const response = await disableUserRequest(userID)
  return response.data
}
